import useTranslation from 'next-translate/useTranslation';

type TooltipMapChartProps = { name: string; value: number; percentage: string };

export function TooltipMapChart({ name, value, percentage }: TooltipMapChartProps) {
    const { t, lang } = useTranslation('analytics');
    return (
        <div className="relative text-left text-xxs">
            <div>{name}</div>
            <div>
                {t('followers')}
                {lang === 'fr' ? ' : ' : ': '}
                {value} ({percentage})
            </div>
        </div>
    );
}
